import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  FaTwitter,
  FaYoutube,
  FaInstagram,
  FaDiscord,
  FaTiktok,
} from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import logo from "./../assets/logomark.svg";

// import star from "./../assets/star.svg"
export default function NewsLetterModal({ opened }) {
  const [open, setOpen] = useState(opened);
  function openModal() {
    setOpen(true);
  }
  function closeModal() {
    setOpen(false);
  }
  useEffect(() => {
    if (opened) {
      openModal();
    }
  }, [opened]);
  return (
    <>
      <Modal show={open} onHide={closeModal} centered>
        <div
          className=" py-5 px-3 px-md-5 bg-dark d-flex flex-column justify-content-around align-items-center text-white"
          style={{ minHeight: "45vh" }}
        >
          <Button
            onClick={closeModal}
            variant=""
            className="text-white position-absolute"
            style={{ right: "10px", top: "10px" }}
          >
            <AiOutlineClose size={24} />
            <span className="visually-hidden">Loading...</span>
          </Button>
          <img src={logo} className="img-fluid " width={68} alt="logo" />

          <div>
            <h4 className="display-6 my-4 fs-3 fw-bold text-start">
              Thanks for joining our newsletter
            </h4>

            <h4 className="display-6 fs-4  my-4">
              Make sure to follow us on the socials
            </h4>
          </div>

          <span className="d-flex ">
            <a
              className="d-flex nav-link my-auto"
              target="_blank"
              rel="noreferrer"
              href="https://www.twitter.com/zerkogg"
            >
              <FaTwitter size={24} className="social_link" />
            </a>

            <a
              className="d-flex nav-link  my-auto"
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/zerkogg"
            >
              <FaInstagram size={24} className="social_link" />
            </a>
            <a
              className="d-flex nav-link  my-auto"
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/zerkogg"
            >
              <FaYoutube size={24} className="social_link" />
            </a>
            <a
              className="d-flex nav-link  my-auto"
              target="_blank"
              rel="noreferrer"
              href="https://discord.gg/ekscSGmg27"
            >
              <FaDiscord size={24} className="social_link" />
            </a>
            <a
              className="d-flex nav-link  my-auto"
              target="_blank"
              rel="noreferrer"
              href="https://www.tiktok.com/@zerkogg?"
            >
              <FaTiktok size={24} className="social_link" />
            </a>
          </span>
        </div>
      </Modal>
    </>
  );
}
